const styles = ({ COLORS }) => ({
  container: {
    maxWidth: '50%',
    textAlign: 'center',
    fontSize: '18px',
    margin: '20px auto 40px',
    lineHeight: '24px'
  },
  link: {
    fontWeight: 'bold',
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none'
  },
  illustration: {
    margin: '20px auto',
    display: 'block',
    maxWidth: '500px'
  },
  restricted: {
    filter: 'grayscale(1)'
  },
  filter: {
    maxWidth: '300px',
    display: 'flex',
    alignItems: 'center'
  },
  label: {
    margin: '0 10px 0 0'
  }
})

export default styles
